// Royal Eco constants
export const COMPANY = {
  name: "Royal Eco",
  tagline: "Gestión Ambiental Responsable y Logística a tu Medida",
  whatsappDisplay: "(011) 5470-9007",
  whatsappE164: "5491154709007", // +54 9 11 5470-9007 (Argentina WhatsApp format)
  officeDisplay: "(02320) 65-8225",
  officeTel: "+542320658225", // +54 2320 65-8225 (Escobar, Buenos Aires)
  email: "residuosroyal@gmail.com",
  emailSecondary: "royaleco.info@gmail.com",
  region: "Provincia de Buenos Aires, Argentina",
  founded: "Más de una década",
};

export const buildWhatsAppLink = (message = "") => {
  const text = encodeURIComponent(
    message ||
      "Hola Royal Eco, me gustaría recibir información sobre sus servicios de gestión ambiental."
  );
  return `https://wa.me/${COMPANY.whatsappE164}?text=${text}`;
};
